// 页面路径：store/index.js
// import Vue from 'vue'
import Vuex from 'vuex'

// Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        count: 1,
        currentPathName:'',
    },
    mutations: {
        add(state, payload) {
            state.count += payload.amount
        },
        setPath(state, pathName) {
            state.currentPathName ='';
            if (pathName!=="首页")
            state.currentPathName = pathName
        }
    },
    getters:{
        getCurrentPathName(state){
            return state.currentPathName;
        }
    },
    actions:{

    }
});
export default store